export const DemoCustomerId ="1411d34c-b3c3-4fec-90ae-345f3b11b33f";
export const DemoRegionId ="afc2345d-edf9-496c-a0f3-6afd5e6f8849";
export const DemoFoodManufacturingSiteId = "7c7491af-c2ab-4e14-ae20-560ebe321dca";
export const DemoPharmaManufacturingSiteId = "923e76d1-eca6-41e6-a628-971c79922085";